import { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import Vid from './Vid';

const Slider = (props) => {
const [enabled,setEnabled] = useState(1);
const [slideIdx,setSlideIdx] = useState(1);
const [slides,setSlides] = useState([0,0,0]);
const [trans, setTrans] = useState(0);
const [direction, setDirection] = useState(0);
let maxSlides = 7;

if(props.gameData.id == 4 || props.gameData.id == 6){
    maxSlides = 6;
}
    const switchHandler = (e) => {
    
        if(e.target.textContent == "Video"){
            setEnabled(2);
        }else{
            setEnabled(1);
        }
    }
    const clickModal = () => {
        if(props.click){
            props.click(slideIdx);
        }
        
    }
    const slideIndex = (idx) => {
        let iterDown = idx - 1;
        let iterUp = idx + 1;
        if(iterDown < 1){
            iterDown = maxSlides;
        }
        if(iterUp > maxSlides){
            iterUp = 1;
        }
        setSlides([iterDown,idx,iterUp]);

    }
   useEffect(()=>{
 
     
    if(props.currentIndex && props.currentIndex != null){
    slideIndex(props.currentIndex);
    setSlideIdx(props.currentIndex);
    }else{
   slideIndex(slideIdx);
    }
    },[props.currentIndex]);
    const nextSlide = () => {
        if(trans == 0){
            let idx = slideIdx - 1;
            if(idx < 1){
                idx = maxSlides;
            }
            setSlideIdx(idx);
            props.set(idx);
            props.switch(idx - 1);
            
        setTrans(1);
        setTimeout(()=>{setDirection(1)},100);
        setTimeout(()=>{setTrans(0);setDirection(0);
            slideIndex(idx);
        },200);
        }
      
    } 

     const prevSlide = () => {
        if(trans == 0){
               let idx = slideIdx + 1;
            if(idx > maxSlides){
                idx = 1;
            }
            setSlideIdx(idx);
                props.set(idx);
               props.switch(idx - 1);
        setTrans(1);
        setTimeout(()=>{setDirection(2)},100);
        setTimeout(()=>{setTrans(0);setDirection(0);
            slideIndex(idx);
        },200);
        }
      
    } 
    
    let dotsArray = [];

    for(let i = 0; i < maxSlides; i++){
       
        dotsArray.push(<div className={`${styles.sliderDot} ${i + 1 == slideIdx && styles['sliderDot--gold']}`}></div>);
    }
    return (
        <div className={`${styles.sliderMain}`}>
            <div className={`${styles.sliderSwitches}`}>
                  <div onClick={switchHandler} className={`${styles.sliderSwitch} ${enabled == 1 && styles['sliderSwitch--enabled']}`}>Images</div>
                   <div onClick={switchHandler} className={`${styles.sliderSwitch} ${enabled == 2 && styles['sliderSwitch--enabled']}`}>Video</div>
             </div>
                     {enabled == 2 && <Vid version={"game"} url={`/videos/${props.gameData.trailer}.mp4`}/>}
            {enabled == 1 &&<div className={`${styles.sliderCentral}`}>
                        <div onClick={clickModal} className={`${styles.allSlides} ${trans == 1 && styles['allSlides--transitionOn']} ${direction == 1 && styles['allSlides--moveRight']} ${direction == 2 && styles['allSlides--moveLeft']}`}>
     <div className={`${styles.sliderSlide}`}
            style={{
               background: `url("/pictures/game-images/${props.gameData.slides}/image${slides[0]}.png") center/cover no-repeat`
            }}
            ></div>
            <div className={`${styles.sliderSlide}`} 
              style={{
               background: `url("/pictures/game-images/${props.gameData.slides}/image${slides[1]}.png") center/cover no-repeat`
            }}></div>
            <div className={`${styles.sliderSlide}`}
              style={{
               background: `url("/pictures/game-images/${props.gameData.slides}/image${slides[2]}.png") center/cover no-repeat`
            }}></div>    

                        </div>
       
            <div className={`${styles.sliderArrow} ${styles['sliderArrow--left']}`} onClick={nextSlide}>›</div>
            <div className={`${styles.sliderArrow} ${styles['sliderArrow--right']}`} onClick={prevSlide}>›</div>
            <div className={`${styles.sliderProgress}`}>
            {dotsArray}


            </div>
        </div>}
        </div>
    );
}


export default Slider;